import * as angular from "angular";

const newsletterDistributionDataTableConfig = {
    template: `
        <mw-table class="mw-outputs-data-table">
            <header class="mw-table__header" ng-class="[{'mw-table__header--selected-items': $ctrl.selectedItems.length}]">
                <!-- default toolbar -->
                <mw-collection-header
                    ng-if="$ctrl.showHeader()"
                    is-search-active="$ctrl.NewsletterDistributionService.isSearchVisible"
                    is-header-title-visible="$ctrl.isHeaderTitleVisible()"
                    on-search="$ctrl.search($event)"
                    search-input-placeholder="{{::$ctrl.$translate.instant('mw-newsletter-distribution-data-table--search-input-placehold__text')}}"
                    on-search-toggle="$ctrl.onSearchToggle($event)" collection-type='table'>

                    <mw-collection-header-title>
                        <span
                            class="mw-collection-header__title"
                            ng-if="$ctrl.isHeaderTitleVisible()">

                            {{$ctrl.$translate.instant('mw-newsletter-distribution-data-table-header__title')}}
                        </span>
                    </mw-collection-header-title>

                    <mw-collection-header-actions>
                        <md-menu class="mw-menu" md-position-mode="target-right target" md-offset="0 50">
                            <mw-menu-trigger-icon-button
                                icon='content:ic_sort_24px'
                                tooltip="{{'Sort' | translate}}"
                                on-click='$mdOpenMenu($event)'></mw-menu-trigger-icon-button>
                            <md-menu-content class="mw-menu-dropdown" md-padding="md-padding">
                                <mw-menu-item
                                    type="singleselect"
                                    ng-repeat="orderBy in $ctrl.NewsletterDistributionService.orderByOptions"
                                    is-selected="$ctrl.convertOrderBy(orderBy) === $ctrl.NewsletterDistributionService.orderBy"
                                    on-click="$ctrl.setOrderBy(orderBy)">

                                    {{$ctrl.$translate.instant(orderBy)}}
                                </mw-menu-item>
                                <md-divider class="mw-menu-divider"></md-divider>
                                <mw-menu-item
                                    type="singleselect"
                                    ng-repeat="sortOrder in $ctrl.NewsletterDistributionService.sortOrderOptions"
                                    is-selected="$ctrl.convertSortOrder(sortOrder) === $ctrl.NewsletterDistributionService.sortOrder"
                                    on-click="$ctrl.setSortOrder(sortOrder)">

                                    {{$ctrl.$translate.instant(sortOrder)}}
                                </mw-menu-item>
                            </md-menu-content>
                        </md-menu>
                    </mw-collection-header-actions>
                </mw-collection-header>
                <!-- selected items toolbar -->
                <mw-collection-bulk-action
                    ng-if="$ctrl.selectedItems.length"
                    selected-items="$ctrl.selectedItems"
                    on-reset-selected-items="$ctrl.resetSelectedItems($event)">
                    <md-button ng-click="$ctrl.openViewNewsletterDistributionDialog($event, $ctrl.selectedItems[0]._id, $ctrl.selectedItems[0].newsletterSubject)"
                        ng-if="$ctrl.selectedItems.length === 1 && $ctrl.selectedItems[0].displayStatus === $ctrl.$translate.instant('Sent')"
                        class="md-icon-button"
                        aria-label="{{::'mw-newsletter-distribution-data-table__action--view' | translate}}">

                        <md-tooltip md-delay="500"><span translate>mw-newsletter-distribution-data-table__action--view</span></md-tooltip>
                        <md-icon md-svg-icon="action:ic_visibility_24px">view</md-icon>
                    </md-button>
                    <md-button ng-click="$ctrl.openNewslettersDistributionStats($event, $ctrl.selectedItems[0]._id)"
                        ng-if="$ctrl.getEnableAnalytics($ctrl.selectedItems[0])"
                        class="md-icon-button"
                        aria-label="{{::'mw-newsletter-distribution-data-table__action--analytics' | translate}}">

                        <md-tooltip md-delay="500"><span translate>mw-newsletter-distribution-data-table__action--analytics</span></md-tooltip>
                        <md-icon md-svg-icon="meltwater:chart-line"></md-icon>
                    </md-button>
                    <md-button ng-click="$ctrl.onRowClick($ctrl.selectedItems[0])"
                        ng-if="$ctrl.selectedItems.length === 1 && $ctrl.selectedItems[0].displayStatus === $ctrl.$translate.instant('Draft')"
                        class="md-icon-button"
                        aria-label="{{::'mw-newsletter-distribution-data-table__action--edit' | translate}}">

                        <md-tooltip md-delay="500"><span translate>Edit</span></md-tooltip>
                        <md-icon md-svg-icon="editor:ic_mode_edit_24px">edit</md-icon>
                    </md-button>
                    <md-button ng-click="$ctrl.copyToDraft($ctrl.selectedItems[0])"
                        ng-if="$ctrl.selectedItems.length === 1 && $ctrl.selectedItems[0].displayStatus === $ctrl.$translate.instant('Sent') && !$ctrl.NewsletterDistributionService.isOneOffNewsletter && !$ctrl.NewsletterDistributionService.isRecurringNewsletter"
                        class="md-icon-button"
                        aria-label="{{::'mw-newsletter-distribution-data-table__action--copy' | translate}}">

                        <md-tooltip md-delay="500"><span translate>Copy to draft</span></md-tooltip>
                        <md-icon md-svg-icon="content:ic_content_copy_24px">Copy to draft</md-icon>
                    </md-button>
                    <md-button
                        ng-click="$ctrl.deleteSelectedItems($ctrl.selectedItems, $event)"
                        class="md-icon-button"
                        aria-label="{{::'mw-newsletter-distribution-data-table__action--delete' | translate}}">

                        <md-tooltip md-delay="500"><span translate>Delete</span></md-tooltip>
                        <md-icon md-svg-icon="action:ic_delete_24px">delete</md-icon>
                    </md-button>
                </mw-collection-bulk-action>
            </header>
            <md-card ng-if="$ctrl.NewsletterDistributionService.filteredItems.length != 0">
                <md-table-container>
                    <table
                        class="mw-table--actions-visible"
                        md-table
                        md-progress="$ctrl.NewsletterDistributionService.loadPagePromise"
                        md-row-select="true"
                        multiple="true"
                        ng-model="$ctrl.selectedItems">

                        <thead md-head md-order="$ctrl.orderBy" md-on-reorder="$ctrl.onReorder">
                            <tr md-row>
                                <th class="mw-table__number-column" md-column md-order-by="nextInstanceId" hide-xs>
                                    <span translate>mw-newsletter-distribution-data-table__table-header--instance</span>
                                </th>
                                <th class="mw-table__text-column mw-table__greedy-column" md-column md-order-by="newsletterSubject">
                                    <span translate>mw-newsletter-distribution-data-table__table-header--subject</span>
                                </th>
                                <th class="mw-table__text-column" md-column md-order-by="displayStatus" hide-xs>
                                    <span translate>mw-newsletter-distribution-data-table__table-header--status</span>
                                </th>
                                <th class="mw-table__date-column" md-column md-order-by="scheduledDate" hide-xs hide-sm>
                                    <span translate>mw-newsletter-distribution-data-table__table-header--schedule</span>
                                </th>
                                <th class="mw-table__actions-column" md-column></th>
                            </tr>
                        </thead>
                        <tbody md-body>
                            <tr md-row
                                ng-repeat="item in $ctrl.NewsletterDistributionService.filteredItems | orderBy: $ctrl.NewsletterDistributionService.orderBy: $ctrl.NewsletterDistributionService.sortOrder === 'DESC' | limitTo: $ctrl.NewsletterDistributionService.paging.itemsPerPage: ($ctrl.NewsletterDistributionService.paging.selectedPage - 1) * $ctrl.NewsletterDistributionService.paging.itemsPerPage track by item._id"
                                md-select="item"
                                md-select-id="_id"
                                md-auto-select="false"
                                ng-click="::$ctrl.onRowClick(item)"
                                id="{{item._id}}">

                                <td class="mw-table__number-column" md-cell hide-xs>
                                    <span>{{item.nextInstanceId}}</span>
                                </td>
                                <td class="mw-table__text-column mw-table__greedy-column" md-cell style="max-width: 450px;">
                                    {{::item.newsletterSubject}}
                                </td>
                                <td class="mw-table__text-column" md-cell hide-xs>
                                    {{::item.displayStatus}}
                                </td>
                                <td class="mw-table__date-column" md-cell hide-xs hide-sm>
                                    {{$ctrl.formatDate(item.scheduledDate)}}
                                </td>
                                <td class="mw-table__actions-column" md-cell>
                                    <md-menu
                                        class="mw-menu"
                                        md-position-mode="target-right target"
                                        md-offset="0 50"
                                        ng-style="{'visibility': $ctrl.selectedItems.length === 0 ? 'visible' : 'hidden'}">

                                        <mw-menu-trigger-icon-button
                                            icon="navigation:ic_more_vert_24px"
                                            tooltip="{{::'mw-collection__tooltip-menu-trigger' | translate}}"
                                            on-click="$mdOpenMenu($event)">
                                        </mw-menu-trigger-icon-button>

                                        <md-menu-content class="mw-menu-dropdown" md-padding="md-padding">
                                            <mw-menu-item type="focusdummy" md-autofocus></mw-menu-item>
                                            <mw-menu-item
                                                icon="action:ic_visibility_24px"
                                                aria-label="{{::'mw-newsletter-distribution-data-table__action--view' | translate}}"
                                                ng-click="$ctrl.openViewNewsletterDistributionDialog($event, item._id, item.newsletterSubject)"
                                                ng-if="item.displayStatus === $ctrl.$translate.instant('Sent')">

                                                {{::$ctrl.$translate.instant('mw-newsletter-distribution-data-table__action--view')}}
                                            </mw-menu-item>
                                            <mw-menu-item
                                                icon="meltwater:chart-line"
                                                aria-label="{{::'mw-newsletter-distribution-data-table__action--analytics' | translate}}"
                                                ng-click="$ctrl.openNewslettersDistributionStats($event, item._id)"
                                                ng-if="$ctrl.getEnableAnalytics(item)">

                                                {{::$ctrl.$translate.instant('mw-newsletter-distribution-data-table__action--analytics')}}
                                            </mw-menu-item>
                                            <mw-menu-item
                                                icon="meltwater:edit"
                                                aria-label="{{::'mw-newsletter-distribution-data-table__action--edit' | translate}}"
                                                ng-click="$ctrl.onRowClick(item, $event)"
                                                ng-if="item.displayStatus === $ctrl.$translate.instant('Draft')">

                                                {{::$ctrl.$translate.instant('Edit')}}
                                            </mw-menu-item>
                                            <mw-menu-item
                                                icon="content:ic_content_copy_24px"
                                                aria-label="{{::'mw-newsletter-distribution-data-table__action--copy' | translate}}"
                                                ng-click="$ctrl.copyToDraft(item, $event)"
                                                ng-if="item.displayStatus === $ctrl.$translate.instant('Sent') && !$ctrl.NewsletterDistributionService.isOneOffNewsletter && !$ctrl.NewsletterDistributionService.isRecurringNewsletter">

                                                {{::$ctrl.$translate.instant('mw-newsletter-distribution-data-table__action--copy')}}
                                            </mw-menu-item>
                                            <mw-menu-item
                                                icon="action:ic_delete_24px"
                                                aria-label="{{::'mw-newsletter-distribution-data-table__action--delete' | translate}}"
                                                ng-click="$ctrl.deleteSingle(item, $event)">

                                                {{::$ctrl.$translate.instant('Delete')}}
                                            </mw-menu-item>
                                    </md-menu>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </md-table-container>
                <md-table-pagination
                    md-limit="$ctrl.NewsletterDistributionService.paging.itemsPerPage"
                    md-page="$ctrl.NewsletterDistributionService.paging.selectedPage"
                    md-total="{{$ctrl.NewsletterDistributionService.paging.totalItems}}"
                    md-on-paginate="$ctrl.onPage" md-label="{of: 'of'}"></md-table-pagination>
            </md-card>
            <md-card class="mw-empty-state__wrapper automatedEmptySpace" ng-if="$ctrl.NewsletterDistributionService.filteredItems.length === 0 && !$ctrl.isLoading && !$ctrl.NewsletterDistributionService.searchText && !$ctrl.isLoading">
                <md-card-content class="mw-empty-state-container">
                    <mw-empty-state icon="communication:ic_no_sim_24px" icon-size="medium" text={{$ctrl.$translate.instant('mw-newsletter-distribution--empty-state__text')}} sub-text={{$ctrl.distributionTypeEmptyStateText()}}>
                        <mw-empty-state-text>{{$ctrl.$translate.instant('mw-newsletter-distribution--empty-state__text')}}</mw-empty-state-text>
                        <mw-empty-state-sub-text>{{$ctrl.distributionTypeEmptyStateText()}}</mw-empty-state-sub-text>
                        <mw-empty-state-actions ng-if="$ctrl.NewsletterDistributionService.isOneOffNewsletter">
                            <md-button class="mw-button" ng-click="$ctrl.editNewsletter()">{{$ctrl.$translate.instant('New Distribution')}}</md-button>
                        </mw-empty-state-actions>
                    </mw-empty-state>
                </md-card-content>
            </md-card>
        </mw-table>
        <section ng-if="$ctrl.NewsletterDistributionService.searchText && $ctrl.NewsletterDistributionService.filteredItems.length === 0">
            <mw-empty-state text="{{$ctrl.translatedEmptySearchResultsText}}"></mw-empty-state>
        </section>
    `,
    selector: 'mwNewsletterDistributionDataTable',
    controller: null
};

class NewsletterDistributionDataTableComponent {
    selectedItems: string[];
    orderBy: any;
    translatedEmptySearchResultsText: string;
    isLoading: boolean;

    constructor(
        private $window,
        private $mdToast,
        private $mdMedia,
        private $http,
        private NewsletterDistributionService,
        private $location,
        private $filter,
        private $translate ,
        private $mdDialog,
        private AnalyticsService,
        private ANALYTICS_CONSTANTS,
        private OutputConfig,
        private EntitlementService,
        private NEWSLETTERS_UI_URL
    ) {
        'ngInject';
        this.selectedItems = [];
        this.isLoading = true;

        // Unfortunately, the md-data-table component does not execute these event handlers with the controller being the
        // context, we need to force it as the context by using angular.bind.
        this.onPage = angular.bind(this, this.onPage);
        this.onReorder = angular.bind(this, this.onReorder);
    }

    $onInit() {
        this.syncOrderBy();
        this.isLoading = true;
        this.NewsletterDistributionService.load()
            .catch((error) => {
                let errorMessage,
                    errorTitle;
                switch(error.message) {
                    case 'newsletterNotFound':
                        errorTitle = 'mw-newsletter__error-title--no-newsletter';
                        errorMessage = 'mw-newsletter__error-text--no-newsletter';
                        break;
                    case 'newsletterDistributionNotFound':
                        errorTitle = 'mw-newsletter__error-title--no-newsletter-distribution';
                        errorMessage = 'mw-newsletter__error-text--no-newsletter-distribution';
                        break;
                    default:
                        errorTitle = 'OOPS';
                        errorMessage = 'Something has gone wrong behind the scenes. Please try again later.';
                }

                this.showNewsletterNotFoundErrorToast(errorTitle, errorMessage);

            })
            .finally(() => this.isLoading = false)
    }

    $onDestroy() {
        this.NewsletterDistributionService.resetNLDDataTable();
    }

    getEnableAnalytics(item) {
        if(this.selectedItems.length <= 1 && item.displayStatus === this.$translate.instant('Sent') && this.NewsletterDistributionService.dynEntitlement && this.NewsletterDistributionService.enableAnalytics) {
            return true;
        } else {
            return false;
        }
    }

    distributionTypeEmptyStateText(){
        if(this.NewsletterDistributionService.isOneOffNewsletter){
            return this.$translate.instant('mw-newsletters__one-off-empty-state--sub-text');
        }
        else if(this.NewsletterDistributionService.isRecurringNewsletter){
            return this.$translate.instant('mw-newsletters__automated-empty-state--sub-text');
        } else {
            return this.$translate.instant('mw-collection__empty-state-subtext--create-new');
        }
    }

    isHeaderTitleVisible() {
        return !(this.$mdMedia('xs') && this.NewsletterDistributionService.isSearchVisible);
    }

    onRowClick(item, $event) {
        switch (item.displayStatus) {
            case this.$translate.instant('Draft') :
                this.$location.url('/newsletter/' + this.NewsletterDistributionService.newsletter._id + '/distribution/'+ item._id+'?stepNum=0');
                break;
            case this.$translate.instant('Sent') :
                this.openViewNewsletterDistributionDialog($event, item._id, item.newsletterSubject);
                break;
        }
    }

    showHeader(){
        if (this.selectedItems.length) {
            return false
        } else if (this.NewsletterDistributionService.filteredItems.length > 0 || this.NewsletterDistributionService.searchText){
            return true;
        } else if (this.NewsletterDistributionService.filteredItems.length === 0) {
            return false;
        } else {
            return true;
        }
    }

    search(searchText) {
        this.NewsletterDistributionService.searchText = searchText;
        this.NewsletterDistributionService.filterNewsletterDistributions(searchText);
        this.translatedEmptySearchResultsText = this.$translate.instant(
            'mw-newsletter-distribution--search-empty-state__text' ,
            {searchText: '"' + this.NewsletterDistributionService.searchText + '"'}
        );
    }

    onSearchToggle(isSearchActive) {
        this.NewsletterDistributionService.searchText = '';
        this.NewsletterDistributionService.isSearchVisible = isSearchActive;
    };

    resetSelectedItems(event) {
        this.selectedItems = [];
    };

    onPage() {
        this.resetTableScroll();
    }

    resetTableScroll() {
        var element = this.$window.document.getElementById('mw-newsletter-table__content');
        if (element) {
            element.scrollTop = 0;
        }
    }

    openSortMenu($mdOpenMenu, event) {
        $mdOpenMenu(event);
    }

    onReorder(order) {
        var sortOrder = 'ASC';

        if (order.substr(0, 1) === '-') {
            sortOrder = 'DESC';
            order = order.substring(1);
        }

        this.NewsletterDistributionService.orderBy = order;
        this.NewsletterDistributionService.sortOrder = sortOrder;
        this.NewsletterDistributionService.paging.selectedPage = 1;
    }

    convertOrderBy(orderBy) {
        switch(orderBy.toLowerCase()) {
            case 'mw-newsletter-distribution-data-table__table-header--status':
            case 'status':
                return 'displayStatus';
            case 'mw-newsletter-distribution-data-table__table-header--subject':
            case 'subject':
                return 'newsletterSubject';
            case 'mw-newsletter-distribution-data-table__table-header--modified':
            case 'modified date':
                return 'modified';
            case 'mw-newsletter-distribution-data-table__table-header--schedule':
            case 'schedule':
                return 'scheduledDate';
            case 'mw-newsletter-distribution-data-table__table-header--instance':
            case 'instance':
                return 'nextInstanceId';
            default:
                return orderBy;
        }
    }

    setOrderBy(orderBy) {
        var _orderBy = this.convertOrderBy(orderBy);
        if (this.NewsletterDistributionService.orderBy !== _orderBy) {
            this.NewsletterDistributionService.orderBy = _orderBy;
            this.syncOrderBy();
        }
    }

    convertSortOrder(sortOrder) {
        return sortOrder.trim().toLowerCase() === 'ascending' ? 'ASC' : 'DESC';
    }

    setSortOrder(sortOrder) {
        var _sortOrder = this.convertSortOrder(sortOrder);
        if (this.NewsletterDistributionService.sortOrder !== _sortOrder) {
            this.NewsletterDistributionService.sortOrder = _sortOrder;
            this.syncOrderBy();

            this.isLoading = true;
            this.NewsletterDistributionService.load()
                .finally(() => this.isLoading = false)
        }
    }

    syncOrderBy() {
        var orderBy = this.NewsletterDistributionService.orderBy;
        if (this.NewsletterDistributionService.sortOrder === 'DESC') {
            orderBy = '-' + orderBy;
        }

        this.orderBy = orderBy;
    }

    showToast(message) {
        this.$mdToast.show(
            this.$mdToast.mwSimpleTimed()
                .textContent(message)
        );
    }

    formatDate(date){
        return this.$filter('mwConvertDateToUserTimezone')(date, this.OutputConfig.OUTPUT_DATE_FORMAT);
    }

    deleteSingle(item , event) {
        this.deleteSelectedItems([item], event);
    }

    deleteSelectedItems(selectedItems, event) {
        var selectedDistributionIds=[],
        me = this;

        this.$mdDialog.show(
            this.$mdDialog.mwConfirm()
                .title(this.$translate.instant('newsletter-distributions__confirm-delete--title'))
                .textContent(this.$translate.instant('newsletter-distributions__confirm-delete--message',{numDistributions: selectedItems.length}))
                .ok(this.$translate.instant('OK'))
                .cancel(this.$translate.instant('Cancel'))
                .targetEvent(event)
        )
            .then(
                () => {
                    selectedItems.forEach(function(distribution) {
                        me.AnalyticsService.trackDistribution(distribution, me.ANALYTICS_CONSTANTS.DELETE);
                        selectedDistributionIds.push(distribution._id);
                    });

                    this.NewsletterDistributionService
                        .deleteDistributions(selectedDistributionIds)
                        .then(
                            () => {
                                this.showToast(this.$translate.instant('newsletter-distributions__confirm-delete--success'));
                                this.resetSelectedItems({});
                            },
                            () => {

                            }
                            )
                },
                () => {

                }
            );
    }

    copyToDraft(distribution, event){
        this.NewsletterDistributionService.copyDistributionDataToDraft(distribution, this.NewsletterDistributionService.newsletter)
            .then(() => {
                this.showToast(this.$translate.instant('newsletter-distributions__confirm-copy--success'));
            })
    }

    showNewsletterNotFoundErrorToast(errorTitle, errorText) {
        this.$mdDialog.show(
            this.$mdDialog.mwAlert()
                .title(this.$translate.instant(errorTitle))
                .textContent(this.$translate.instant(errorText))
                .ok(this.$translate.instant('OK'))
        ).then(
            () => {
                this.$location.url('/outputs/newsletters');
            }
        );
    }

    openViewNewsletterDistributionDialog(ev, distributionId, subjectLine) {
        this.$mdDialog.show({
            template: `
                <mw-view-newsletter-distribution
                    distribution-id="$ctrl.distributionId"
                    subject-line="$ctrl.subjectLine"
                    class="mw-flexi-modal">
                </mw-view-newsletter-distribution>
            `,
            locals: {
                distributionId: distributionId,
                subjectLine: subjectLine
            },
            controller: () => {
            },
            controllerAs: '$ctrl',
            bindToController: true,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: true,
            autoWrap: false,
        })
    }

    openNewslettersDistributionStats(ev, distributionId) {
        if (distributionId) {
            window.location.href = this.NEWSLETTERS_UI_URL + '/' + this.NewsletterDistributionService.outputId  + '/distribution/' + distributionId + '/analytics';
        }
    }

    editNewsletter() {
        this.$location.url('/newsletter/edit/' + this.NewsletterDistributionService.newsletter._id + '?stepNum=0');
    }
}

newsletterDistributionDataTableConfig.controller = NewsletterDistributionDataTableComponent;

export {
    newsletterDistributionDataTableConfig,
    NewsletterDistributionDataTableComponent as default
};



/** WEBPACK FOOTER **
 ** ./apps-ts/outputs/src/app/newsletter-distributions/newsletter-distribution-data-table/newsletter-distribution-data-table.component.ts
 **/